module.exports = __webpack_public_path__ + "img/personal.406b6cda.svg";